import { ArrowLeftOutlined, SaveOutlined, UploadOutlined } from '@ant-design/icons'
import { Button, Card, Col, Form, message, Row, Select, Space, Table, Typography, Upload, Input, DatePicker, TimePicker, Transfer, Flex, Image, Tooltip} from 'antd'
import { useEffect, useRef, useState } from 'react'
import api from '../../API';
import * as XLSX from 'xlsx';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import dayjs from 'dayjs';

const contactColumns = [
    {
      title: "Contact Name",
      dataIndex: "display_name",
    },
    {
      title: "Phone",
      dataIndex: "phone",
    }
];

function ZNS() {
  const navigate = useNavigate();
  const location = useLocation();
  const [znstpls, contacts, segments, segmentsAndContacts, oaccounts] = location.state;
  const [form] = Form.useForm()
  const [ZnsDataSourse, setZnsDataSourse] = useState([]);
  const [loading, setLoading] = useState({spin: false, contact: false, btn: false,  upload: false, table: false});
  const [options1, setOptions1] = useState([]);
  const [options2, setOptions2] = useState([]);
  const [options3, setOptions3] = useState([]);
  const [ZnsColumns, setZnsColumns] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);
  const filterContactsByOAID= useRef([]);
  const [allowedColumn, setAllowedColumn] = useState([]);
  const [isOpenUpload, setIsOpenUpload] = useState(false);
  const [contactData, setContactData] = useState([]);
  const [selectedOAId ,setSelectedOAId] = useState(null);
  const [phonesUpload, setPhoneUpload] = useState([])
  const [selectedContactIds ,setSelectedContactIds] = useState([]);
  const now = useRef((new Date()).toLocaleDateString('en-CA'));
  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    setLoading({...loading, spin: true, contact: true});
    setOptions2([{value: 'All', label: 'All'}, ...segments.map(({id: value, segmentName: label}) => ({value, label}))]);
    setOptions3(oaccounts.map((oaccount, i) => ({ value: i, label: oaccount.accountName})))
    filterContactsByOAID.current = contacts.concat();
    setLoading({...loading, spin: false, contact: false});
  }, [])

  function handleSelectedOAAccount (selectedValue) {
    filterContactsByOAID.current = contacts.filter(contact => contact.OAId === oaccounts[selectedValue].OAId);
    setContactData(contacts.filter(contact => contact.OAId === oaccounts[selectedValue].OAId));
    setOptions1(znstpls.filter(znstpl => znstpl?.OAId === oaccounts[selectedValue].OAId).map((obj, i) => ({value: i, label: obj.templateName })));
    setSelectedOAId(oaccounts[selectedValue].OAId);
  }

  function handleselectedContactIds(selectedValue) {
    if(selectedValue === 'All') {
      setContactData(filterContactsByOAID.current);
      setSelectedContactIds(segmentsAndContacts.map((obj) =>  obj.contactId))
    }
    else {
      let contactIds = segmentsAndContacts.reduce((prevArr, obj) => obj.segmentId === selectedValue? [...prevArr, obj.contactId]: prevArr, [])
      setContactData(filterContactsByOAID.current.filter(obj=> contactIds.includes(obj.key)))
      setSelectedContactIds(contactIds)
    }
  }

  async function handleSelectedTemplateId(selectedValue) {
    try {
      setZnsColumns([]);
      setZnsDataSourse([]);
      const tblNames = await api.list_znstemplate_detail_on_zalo(
        user?.parentId ? user.parentId : user.userId,
        znstpls[selectedValue].OAId,
        znstpls[selectedValue].templateId
      );
      setAllowedColumn(tblNames);
      setIsOpenUpload(true);
    } catch (error) {
      message.error(error.message);
    }
  }

  const handleUpload = async ({ file }) => {
    try {
      setLoading((prevObj) => ({ ...prevObj, upload: true, table: true }));
      const arrayBuffer = await file.originFileObj.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      const columns = rows[0].map((column) => ({
        title: column,
        dataIndex: column,
      }));
      if(rows[0].slice(1).some(tblName => !allowedColumn.includes(tblName))) return message.error('The uploaded file does not match this ZNS template!')
      const data = rows.slice(1).map((row, i) => ({
        key: i,
        ...row.reduce((obj, val, index) => {
          obj[columns[index].dataIndex] = val;
          return obj;
        }, {}),
      }));
      const deliveryPhones = data.map(obj => {
        if(obj?.delivery_phone?.toString().slice(0,2) !== '84' && obj?.delivery_phone?.toString()?.length === 9) return '84'+ obj?.delivery_phone;
        if(obj[columns[1].dataIndex]?.toString().at(0) === '0' && obj[columns[1].dataIndex]?.toString()?.length === 10) return '84'+ obj[columns[1].dataIndex]?.slice(1);
        return obj?.delivery_phone?.toString();
      });
      filterContactsByOAID.current = contacts.filter(contact => !deliveryPhones.includes(contact?.phone) && contact.OAId === selectedOAId);
      setContactData(selectedContactIds.length > 0? filterContactsByOAID.current.filter(obj=> selectedContactIds.includes(obj.key)): filterContactsByOAID.current);
      setPhoneUpload(deliveryPhones)
      setZnsColumns(columns);
      setZnsDataSourse(data);
      message.success("File uploaded successfully")
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading((prevObj) => ({ ...prevObj, upload: false, table: false }));
    }
  };

  function getMessage (obj) {
      try {
        let messageBody = JSON.stringify({
          template_data: {
           ...obj
          }})
        return messageBody;
      } catch (error) {
        throw error;
      }
    }

  async function handleSubmit(values) {
      let cmpId = null;
      try {
        if(ZnsDataSourse.length) {
          setLoading({...loading, btn: true})
          const {OAAccountIndex, campaignName, startDate, startTime, contactIds, templateIndex} = values;
          // let sendContacts = contacts.reduce((prevArr, {key, phone}) => contactIds.includes(key)? [...prevArr, phone] :  prevArr, []);
          // sendContacts.concat(phonesUpload);
          let campaignObj = {
            campaignName, 
            startDate: (new Date(startDate)).toLocaleDateString('en-CA'), 
            startTime: (new Date(startTime)).toLocaleTimeString('it-IT'),
            template_type: "ZNS",
            msgVolume: ZnsDataSourse.length,
            // msgVolume: sendContacts.length,
            templateId: 1,
            createDate: now.current,
            userId: user?.userId,
            accountId: oaccounts[OAAccountIndex].id,
            OAId: oaccounts[OAAccountIndex].OAId
          };
          const responseCmp = await api.create_new_campaignzns(campaignObj);
          cmpId = responseCmp.result.insertId;
          const messageArr = ZnsDataSourse.map(({delivery_phone, key, ...zns}) =>{
            let msg = {
              campaignId: cmpId,
              accountId: oaccounts[OAAccountIndex].id,
              OAId: oaccounts[OAAccountIndex].OAId,
              userId: user?.userId,
              TemplateId: znstpls[templateIndex].templateId,
              znsTplId: znstpls[templateIndex].id,
              phoneNumber: (delivery_phone?.toString().slice(0,2) !== '84' && delivery_phone?.toString()?.length === 9)? '84'+ delivery_phone: delivery_phone,
              messageBody: getMessage(zns),
              insertAt: (new Date()).toLocaleDateString('en-CA')
            }
            return msg;
          });
            await Promise.all(messageArr.map(msg => api.create_new_messageszns(msg)));
            message.success(responseCmp.message);
            navigate(`/znscamapaign`, { replace: true });
        } else message.error('ZNS table cannot be empty!')
      } catch (error) {
          message.error(error.message);
          if(cmpId !== null) api.delete_campaignzns_byId(cmpId).catch((err) => message.error(err.message))
      } finally {
          setLoading({...loading, btn: false})
      }
  }

  return (
      <Card 
          style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
          title={
          <Space>
              <Link to={`/znscamapaign`} replace={true}>
                      <Button style={{width: 50}} icon={<ArrowLeftOutlined />}></Button>
              </Link>
              <Typography.Title level={5} style={{margin: 0}}>Create new ZNS campaign</Typography.Title>
          </Space>
          }
          loading={loading.spin}
      >
        <Form name="campaignform" label="campaign form" layout="vertical" form={form} onFinish={handleSubmit}>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label='OA Account'
                        name="OAAccountIndex"
                        rules={[{required: true, message: 'The OA Account cannot be empty'}]}>
                <Select 
                  options={options3} 
                  placeholder="Select OA Account" 
                  showSearch
                  onChange={handleSelectedOAAccount}
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
              <Form.Item label='Name'
                         name='campaignName'
                         rules={[{required: true, message: 'The campaign name cannot be empty'}]}>
                <Input placeholder="Enter campaign name..." />
              </Form.Item>
              <Space styles={{item: {width: '100%'}}} style={{width: '100%'}}>
                <Form.Item label='Schedule Date'
                          name='startDate'
                          rules={[{required: true, message: 'The date cannot be empty'}]}>
                  <DatePicker style={{width: '100%'}} disabledDate={(current) => current && current < dayjs().startOf('day')}/>
                </Form.Item>
                <Form.Item label='Schedule Time'
                          name='startTime'
                          rules={[{required: true, message: 'The time cannot be empty'}]}>
                  <TimePicker format="HH:mm" style={{width: '100%'}}/>
                </Form.Item>
              </Space>
              <Form.Item  label="ZNS Template"
                        name="templateIndex"
                        rules={[{required: true, message: 'Template code must be selected'}]}>
                  <Select 
                    options={options1} 
                    placeholder="Select template code" 
                    showSearch 
                    onChange={handleSelectedTemplateId}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                  />
            </Form.Item>
              <Form.Item  label="ZNS File"
                          required
                          rules={[{required: true, message: 'Zns cannot be empty'}]}>
                  <Space direction='vertical' style={{width: '100%'}}>
                      {isOpenUpload && 
                      <Upload
                          accept='.xlsx'
                          customRequest={({onSuccess})  => onSuccess('ok')}
                          style={{position: "absolute"}}
                          onChange={handleUpload}
                          itemRender= {() => null}
                          loading={loading.upload}
                      >
                          <Button type='primary' icon={<UploadOutlined />}>Upload Excel</Button>
                      </Upload>}
                      <Table  
                          bordered
                          scroll={{x: 1200}}
                          columns= {ZnsColumns}
                          style={{width: '100%'}} 
                          dataSource={ZnsDataSourse}
                          loading={loading.table}
                          pagination={{
                              position: ["bottomCenter"],
                              showSizeChanger: false, // Disable page size changer
                              pageSize: 10, 
                              showTotal: () => `Total: ${ZnsDataSourse.length} items`
                          }}
                      />
                  </Space>
              </Form.Item>
              {/* <Form.Item label="Choose segments">
                <Select 
                  options={options2} 
                  placeholder="Select segment" 
                  onChange={handleselectedContactIds} popupMatchSelectWidth={false}
                  showSearch 
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                />
              </Form.Item>
              <Form.Item  label="Choose contacts" 
                name='contactIds' 
                style={{width: '100%'}}
                valuePropName="targetKeys" 
                getValueFromEvent={(nextTargetKeys) => nextTargetKeys}>
                <Transfer
                  titles={['Source', 'Target']}
                  dataSource={contactData.map(contact => ({ key: contact.key, display_name: contact.display_name, phone: contact.phone}))}
                  targetKeys={targetKeys}
                  showSearch
                  showSelectAll={false}
                  listStyle={{width: '40%'}}
                  onChange={(nextTargetKeys)=>{setTargetKeys(nextTargetKeys)}}
                  filterOption={(input, item) => ((item.phone && String(item.phone).includes(input)) || item.zaloUid?.includes(input))}>
                  {({
                    filteredItems,
                    onItemSelect,
                    onItemSelectAll,
                    selectedKeys: listSelectedKeys,
                  }) => {
                    const rowSelection = {
                      onChange(selectedRowKeys) {
                        onItemSelectAll(selectedRowKeys, 'replace');
                      },
                      selectedRowKeys: listSelectedKeys,
                      selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE],
                    };
                    return (
                      <Table
                        loading= {loading.contact}
                        rowSelection={rowSelection}
                        columns={contactColumns}
                        dataSource={filteredItems}
                        size="small"
                        scroll={{x: '40%'}}
                        onRow={({ key}) => ({
                          onClick: () => {
                            onItemSelect(key, !listSelectedKeys.includes(key));
                          },
                        })}
                        pagination={{
                          position: ["bottomCenter"],
                          showSizeChanger: false, // Disable page size changer
                          pageSize: 5
                        }}
                      />
                    );
                  }}
                </Transfer>
              </Form.Item> */}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item style={{marginTop: 10}}>
                <Button type="primary" htmlType="submit" loading={loading.btn} icon={<SaveOutlined/>}>Save</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
  )
}

export default ZNS
